import { IAppointmentProps } from './Appointment'

export interface ICalendarEventProps {
  id?: string
  google?: string[]
  microsoft?: string[]
  name?: string | null
  description?: string | null
  start?: string | null
  end?: string | null
  timed?: boolean
  color?: string | null
  textColor?: string | null
  appointment?: IAppointmentProps | null
}

export default class CalendarEventEntity {
  private _props: ICalendarEventProps

  constructor(props?: ICalendarEventProps | null) {
    this._props = EmptyCalendarEventPropsFactory(props)
  }

  get props(): ICalendarEventProps {
    return this._props
  }

  get clone(): ICalendarEventProps {
    return JSON.parse(JSON.stringify(this._props))
  }

  get id(): string | undefined {
    return this._props.id
  }
}

export const EmptyCalendarEventPropsFactory = (props?: Partial<ICalendarEventProps> | null): ICalendarEventProps => ({
  name: '',
  description: null,
  start: '',
  end: '',
  timed: true,
  color: null,
  textColor: '#030B20',
  ...props
})
